import { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import CommandPalette from '@/components/navigation/CommandPalette';
import { Toaster } from '@/components/ui/sonner';
import { useTheme } from '@/hooks/useTheme';
import { cn } from '@/lib/utils';

export default function AppShell({ children }: { children: React.ReactNode }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false);
  const { theme } = useTheme();

  // Stänger meny på länk eller overlay
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div
      className={cn(
        'w-screen min-h-screen min-h-dvh flex flex-col bg-background',
        theme === 'dark' && 'dark',
      )}
    >
      <a className="skip-link" href="#main-content">
        Hoppa till huvudinnehåll
      </a>
      <CommandPalette
        open={commandPaletteOpen}
        onOpenChange={setCommandPaletteOpen}
      />
      <Header
        onMenuClick={() => setSidebarOpen((v) => !v)}
        onCommandPaletteOpen={() => setCommandPaletteOpen(true)}
      />
      <div className="flex-1 flex min-h-0">
        <Sidebar open={sidebarOpen} onClose={closeSidebar} />
        {/* Main-content fyller återstående utrymme via flexlayout */}
        <main
          className="app-shell-main flex-1 min-h-0 overflow-auto bg-background"
          id="main-content"
          tabIndex={-1}
        >
          {children}
        </main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
